<div class="export-menu layers2" [ngClass]="this.menuService.menuOptions['new-layers'] ? 'active' : ''">
  <div class="layers__container">
    <h1>New Layers</h1>
    <div class="btn">
      <div class="select_feature active"></div>
      <div class="polygon_select"></div>
      <div class="circle_select"></div>
      <div class="clear_select"></div>
    </div>
    <div class="layers__tab ">
      <div class="title" >
          <p>Areas</p>
          <span class="titleTrigger"></span>
          <div class="create"></div>
          <div class="deleteAllArea"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span class="remove"></span>
                    <span class="editWindow"></span>
                    <span class="openWindow"></span>
                    <span class="text">Lorem Ipsum</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layers__tab ">
      <div class="title" >
          <p>Annotations</p>
          <span class="titleTrigger"></span>
          <div class="create"></div>
          <div class="deleteAllArea"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec">
                  <div class="options">
                    <input type="checkbox">
                    <span class="remove"></span>
                    <span class="editWindow"></span>
                    <span class="openWindow"></span>
                    <span class="text">Lorem Ipsum</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layers__tab ">
      <div class="title" >
          <p>Static Layers</p>
          <span class="titleTrigger"></span>
          <div class="create"></div>
          <div class="deleteAllArea"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span class="text">Open Street Maps</span>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span class="text">NE:NE</span>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span class="text">OWS Mundialis</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layers__tab active">
      <div class="title" >
          <p>Navaids</p>
          <span class="titleTrigger"></span>
          <div class="filter"></div>
          <div class="dots">...</div>
      </div>
      <div class="btn">
        <div class="select_feature active"></div>
        <div class="polygon_select"></div>
        <div class="circle_select"></div>
        <div class="clear_select"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/navaid_DME-gray.svg" alt="">
                    </span>
                    <span class="text">DME</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/navaid_VOR_DME-gray.svg" alt="">
                    </span>
                    <span class="text">VOR/DME</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/navaid_TACAN-gray.svg" alt="">
                    </span>
                    <span class="text">TACAN</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/navaid_VORTAC-gray.svg" alt="">
                    </span>
                    <span class="text">VORTAC</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/navaid_DME_ILS-gray.svg" alt="">
                    </span>
                    <span class="text">DME/ILS</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/navaid_NDB-gray.svg" alt="">
                    </span>
                    <span class="text">NDB</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                <div class="options">
                  <input type="checkbox">
                  <span>
                    <img src="/assets/img/navaid_VOR-gray.svg" alt="">
                  </span>
                  <span class="text">VOR</span>
                  <div class="dots">...</div>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layers__tab active">
      <div class="title" >
          <p>Coordinate Points</p>
          <span class="titleTrigger"></span>
          <div class="filter"></div>
          <div class="dots">...</div>
      </div>
      <div class="btn">
        <div class="select_feature active"></div>
        <div class="polygon_select"></div>
        <div class="circle_select"></div>
        <div class="clear_select"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/cp4-gray.svg" alt="">
                    </span>
                    <span class="text">Waypoints</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/cp5-gray.svg" alt="">
                    </span>
                    <span class="text">ARP</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/cp2-gray.svg" alt="">
                    </span>
                    <span class="text">RWY THR</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/cp1-gray.svg" alt="">
                    </span>
                    <span class="text">Airspace Vertex</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/cp3-gray.svg" alt="">
                    </span>
                    <span class="text">Fix Points</span>
                    <div class="dots">...</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layers__tab ">
      <div class="title" >
          <p>Procedures</p>
          <span class="titleTrigger"></span>
          <div class="filter"></div>
          <div class="dots">...</div>
      </div>
      <div class="btn">
        <div class="select_feature active"></div>
        <div class="polygon_select"></div>
        <div class="circle_select"></div>
        <div class="clear_select"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/SID-red.svg" alt="">
                    </span>
                    <span class="text">SID</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/SID-green.svg" alt="">
                    </span>
                    <span class="text">STAR</span>
                    <div class="dots">...</div>
                  </div>
              </div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/SID-darkblue.svg" alt="">
                    </span>
                    <span class="text">ENROUTE</span>
                    <div class="dots">...</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layers__tab ">
      <div class="title" >
          <p>Trajectories</p>
          <span class="titleTrigger"></span>
          <div class="filter"></div>
          <div class="dots">...</div>
      </div>
      <div class="btn">
        <div class="select_feature active"></div>
        <div class="polygon_select"></div>
        <div class="circle_select"></div>
        <div class="clear_select"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/SID-red.svg" alt="">
                    </span>
                    <span class="text">Trajectory</span>
                    <div class="dots">...</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layers__tab ">
      <div class="title" >
          <p>Air Space Boundaries</p>
          <span class="titleTrigger"></span>
          <div class="filter"></div>
          <div class="dots">...</div>
      </div>
      <div class="btn">
        <div class="select_feature active"></div>
        <div class="polygon_select"></div>
        <div class="circle_select"></div>
        <div class="clear_select"></div>
      </div>
      <div>
        <div class="field">
          <div>
            <div>
              <div class="layers__tab__sec active">
                  <div class="options">
                    <input type="checkbox">
                    <span>
                      <img src="/assets/img/airspaceboundaries.svg" alt="">
                    </span>
                    <span class="text">Air Space Boundary</span>
                    <div class="dots">...</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
